module.exports = __webpack_public_path__ + "img/icon-web-home-04.d3fbd660.png";